import { noForwardProps } from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import { ReactNode } from 'react'

const MainContainer = styled(Box)`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 12px;
  background-color: 'rgba(0, 0, 0, 0.05)';
`

const ContentWrapper = styled(Box, noForwardProps)<ContentWrapperProps>`
  filter: ${props => props.__active && 'blur(8px)'};
`

const TextContainer = styled(Box)`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`

const BlurEffect = ({ children, active, text }: BlurEffectProps) => {
  return (
    <MainContainer>
      <ContentWrapper __active={active}>{children}</ContentWrapper>

      {active && <TextContainer>{text}</TextContainer>}
    </MainContainer>
  )
}

type BlurEffectProps = {
  children: ReactNode
  active: boolean
  text: string | ReactNode
}

type ContentWrapperProps = {
  __active: boolean
}

export default BlurEffect
